"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getNonDiscontinuedAndCannotBeSold = void 0;
const getNonDiscontinuedAndCannotBeSold = products => products.filter(product => !product.isDiscontinuedAndCannotBeSold);
exports.getNonDiscontinuedAndCannotBeSold = getNonDiscontinuedAndCannotBeSold;